import React from "react";
import { PageLayout } from "..";

export default function AppraisalLoading() {
  return (
    <PageLayout>
      <PageLayout.Header title="" step={0} />
      <PageLayout.Content>
        <div className="appraisal-loader">
          <span className="btn-loader appraisal-loading" />
        </div>
      </PageLayout.Content>
    </PageLayout>
  );
}
